(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-video-float"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-video-float')) {
    class ProductVideoFloat extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.media = this.querySelector('.pvf__media');
        this.template = this.querySelector('template');
        this.querySelector('.pvf__tab').addEventListener('click', () => this.open());
        this.querySelector('.pvf__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          const video = this.media.querySelector('video');
          if (video) video.pause();
        });
        const gallery = document.querySelector('.product-images') || document.querySelector('.product-gallery');
        if (gallery && 'IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            entries.forEach((entry) => this.classList.toggle('is-away', !entry.isIntersecting));
          }).observe(gallery);
        }
      }

      open() {
        const firstOpen = !this.media.firstElementChild;
        if (firstOpen) {
          this.media.appendChild(this.template.content.cloneNode(true));
        }
        this.dialog.showModal();
        const video = this.media.querySelector('video');
        if (video && !firstOpen) {
          const playing = video.play();
          if (playing) playing.catch(() => {});
        }
      }
    }
    customElements.define('product-video-float', ProductVideoFloat);
  }

  } catch(e) { console.error(e); }
})();
})();
